<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="许可决定书名称" min-width="100" >
            <template slot-scope="scope">
              {{ scope.row.license_decision_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可文件名称">
            <template slot-scope="scope">
              {{ scope.row.license_file_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可类型">
            <template slot-scope="scope">
              {{ scope.row.license_type || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可机关名称">
            <template slot-scope="scope">
              {{ scope.row.license_agency_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="许可内容" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.license_content || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="决定日期">
            <template slot-scope="scope">
              {{ scope.row.decision_date || '-' }}
            </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'licenseList',
    data() {
        return {
            title: '行政许可',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>